import { createStore } from '@stencil/store';
import { FlowStatus } from '../models/FlowStatus';
import { EctStore } from '../models/IEctStore';
import { db } from './db';

const { state, onChange } = createStore<EctStore>({
  flowStatus: FlowStatus.NONE,
  initialized: false,
  environment: 'DOCKER',
  debug: false,
  requestId: '',
  redirectId: '',
  token: '',
  cameraIds: [],
  cameraId: '',
  phoneNumber: '',
  apiBaseUrl: 'https://apiontrace.id-kyc.com',
  redirectBaseUrl: '',
  device: null,
  sensors: null,
  langIso: 'ro',
  logSteps: false,
  idModelsPath: '',
  faceModelsPath: '',
  citizenship: '',
  idDocument: '',
  showCitizenshipSelector: false,
  scrollMode: false,
  analytics: true,
  videoRecording: false,
  glareTreshold: 30,
  blurTreshold: 90,
  idType: '',
  hasTilt: false,
  manualCaptureTimeout: 30,
  manualCaptureEnabled: false,
  detectedCountryCode: '',
});

onChange('environment', value => {
  state.debug = value == 'QA';
});

onChange('flowStatus', async value => {
  state.flowStatus = value;
  if (state.flowStatus == FlowStatus.CITIZENSHIP) {
    return;
  }
  var ectData = await db.ectdata.get(state.requestId);
  if (ectData) {
    ectData.flowStatus = state.flowStatus;
    await db.ectdata.put(ectData);
  }
});

export default state;
